import { render, staticRenderFns } from "./WinAward.vue?vue&type=template&id=db155558&scoped=true"
import script from "./WinAward.vue?vue&type=script&lang=js"
export * from "./WinAward.vue?vue&type=script&lang=js"
import style0 from "./WinAward.vue?vue&type=style&index=0&id=db155558&prod&lang=scss"
import style1 from "./WinAward.vue?vue&type=style&index=1&id=db155558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db155558",
  null
  
)

export default component.exports